module.exports = __webpack_public_path__ + "static/img/M-600-SILKEN-MAPLE.ec8fe69.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-600-SILKEN-MAPLE.png
// module id = dWME
// module chunks = 0